import React, { useCallback } from "react";
import { useAtom } from "jotai";

import BottomDrawer from "../BottomDrawer/BottomDrawer";
import PayWall from "./PayWall";
import { paywallDrawerOpenAtom } from "../../jotai/atoms/games";

export default function PayWallDrawer() {
  const [isOpen, setIsOpen] = useAtom(paywallDrawerOpenAtom);
  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={handleClose}
      containerClass="paywall-drawer-container p-0"
      headingClass="paywall-drawer-header"
      bodyClass="pt-0"
      closeBtnStyles={{
        zIndex: 10,
      }}
    >
      <PayWall handleSuccessfulSubscription={handleClose} />
    </BottomDrawer>
  );
}
